import { NOTE_KEYWORDS } from '@/pages/Order/constants'
import { checkoutTypeEnumFullName } from '@/resources/enums/checkoutType'

export const isCbe = (
  checkoutType: string = checkoutTypeEnumFullName.DEFAULT
) => checkoutType === checkoutTypeEnumFullName.CBE

export const isOrderChecked = (
  orderNumbers: readonly string[],
  orderNumber: string
) => orderNumbers.includes(orderNumber)

export const formatProductName = (name: string) => {
  if (!name.length) return ''

  return name.split(/( - | \| )/)[0]
}

export const isRoomTemperature = (orderNote: string = '') =>
  orderNote?.includes(NOTE_KEYWORDS.ROOM_TEMPERATURE)
